import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map, pluck, tap } from 'rxjs/operators';
import { StoreFacadeService } from './store-facade.service';

export interface ICompany {
  iIdEmpresa: number;
  vcMensajeCliente: string;
  vcNombreEmpresa: string;
  vcRazonSocial: string;
}

interface ILoginResponse {
  result: {
    token: string;
    tokenChatbot: string;
    firstName: string;
    lastName: string;
    id: number;
    data?: {
      token: string;
      tokenChatbot: string;
      firstName: string;
      lastName: string;
      id: number;
    };
  };
}

// Nueva interfaz para tu API
interface IUserData {
  id: number;
  firstName: string;
  lastName: string;
  token: string;
  iat?: number;
  exp?: number;
}

interface IApiLoginResponse {
  Mensaje: string;
  Dato: IUserData;
  MensajeDev: string | null;
  IsSuccess: boolean;
}

interface ICompanyPagination {
  result: {
    items: ICompany[];
  };
}

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  constructor(
    private http: HttpClient,
    private storeFacadeSv: StoreFacadeService,
    @Inject('env') private env: any
  ) {
    this.storeFacadeSv.selectProfile()
      .subscribe(profile => this.saveUser(profile));
  }

  login(email: string, password: string, recaptcha: string = '', siWeb: number, userType: 'P' | 'C' | 'T'): Observable<IApiLoginResponse> {
    this.resetStore();

    const url = `${this.env.apiHigiene}/auth/login`;
    const body = {
      email: email,
      siWeb: siWeb,
      password: window.btoa(password),
      recaptcha: recaptcha
    };

    return this.http.post<IApiLoginResponse>(url, body).pipe(
      tap(res => {
        if (res.Dato) {
          this.saveToken(res.Dato.token);
          this.saveTokenChatbot(res.Dato.token || '');
        }
      }),
      tap((res: IApiLoginResponse) => {
        // Dispatch login con los datos de tu API
        if (res.Dato) {
          this.storeFacadeSv.dispatchLogin(res.Dato.firstName, res.Dato.lastName, res.Dato.id, userType, siWeb)
        }
      })
    );
  }

  logOut() {
    this.resetStore();
    localStorage.removeItem('appointment_data');
    localStorage.removeItem('appointment_data_temp');
    this.storeFacadeSv.dispatchLogout();
  }

  getCompanies(userId: number) {
    const url = `${this.env.apiHigiene}/empresa/misempresas/${userId}`;
    return this.http
      .get<any>(url)
      .pipe(
        map((res: any) => {
          if (res.Dato && res.Dato.items) {
            return res.Dato.items;
          }
          return res.result?.items || [];
        })
      );
  }

  getIdentificationTypes() {
    const url = `${this.env.api}/v1/clase-generica/data/listar-por-clase/tipo_identificacion`;
    return this.http.get(url).pipe(pluck('result'));
  }

  getGenders() {
    const url = `${this.env.api}/v1/clase-generica/data/listar-por-clase/genero`;
    return this.http.get(url).pipe(pluck('result'));
  }

  updateContactData(body: any) {
    const url = `${this.env.api}/v1/cuenta/actualizar-datos-contacto`;
    return this.http.post(url, body).pipe(
      catchError(error => of(error))
    );
  }

  recoverPassword(body: any) {
    body = { ...body };
    const url = `${this.env.api}/v1/cuenta/recuperar-clave-instruccion`;
    return this.http.post(url, body).pipe(
      catchError(error => of(error))
    );
  }

  seleccionarByDNI(dni: string): Observable<any> {
    const url = `${this.env.api}/v1/cuenta/seleccionar-by-DNI/1/${dni}`;
    return this.http.get(url);
  }

  getToken() {
    return localStorage.getItem('access_token');
  }

  getTokenChatbot() {
    return localStorage.getItem('access_token_chatbot');
  }

  private saveUser(profile: any) {
    localStorage.setItem('current_user', JSON.stringify(profile));
  }

  private saveToken(token: string) {
    localStorage.setItem('access_token', token);
  }

  private saveTokenChatbot(token: string) {
    localStorage.setItem('access_token_chatbot', token);
  }

  private resetStore() {
    localStorage.removeItem('access_token');
    localStorage.removeItem('current_user');
    localStorage.removeItem('access_token_chatbot');
  }

  updatePassword(body: any) {
    body = { ...body };
    const url = `${this.env.api}/v1/cuenta/actualizar-mi-clave`;
    return this.http.put(url, body);
  }


}
